import React from 'react';
import { IconButton, Tooltip, Zoom, Typography } from '@mui/material';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

export const Zooming = (props) => {
  let { direction, disabled } = props;
  return (
    <Tooltip
      disableInteractive
      TransitionComponent={Zoom}
      title={
        <React.Fragment>
          <Typography color="inherit">
            Zoom {direction} with {props.zoomText}
          </Typography>
        </React.Fragment>
      }
    >
      <div>
        <IconButton
          size="large"
          color="primary"
          disabled={disabled}
          onClick={props.onClick}
          data-qa={direction == 'in' ? 'qa-zoom-in' : 'qa-zoom-out'}
        >
          {direction == 'in' ? (
            <AddCircleOutline fontSize="large" />
          ) : (
            <RemoveCircleOutline fontSize="large" />
          )}
        </IconButton>
      </div>
    </Tooltip>
  );
};
